import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IRegionList } from '../../../types/regionList';

export enum EGetRegionListActionType {
  Succeed = 'regionList/getRegionList/succeed',
}

export type TGetRegionListSucceed = ITypedReduxAction<EGetRegionListActionType.Succeed, IRegionList>;

export type TGetRegionList = TGetRegionListSucceed;
